import {UISidebarController} from '../../../ui_html/new_layout/UISidebarController'
import {UIDStoreController} from '../../../store/UIDStoreController.ts'
import {ViewPopupRewardsProgram} from '../../../ui_popup/ViewPopupRewardsProgram.ts'
import {ShareActivityLinkAnalytics} from '../../../../../../shared/entity_datas/EntityDatas.ts'

export class UIDStoreSceneController {
    private readonly sidebarController: UISidebarController
    private readonly storeSceneContainerDiv: HTMLDivElement
    readonly storeController: UIDStoreController

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.storeSceneContainerDiv = document.getElementById('scene_discord_store_container') as HTMLDivElement
        this.storeController = new UIDStoreController()
    }

    hide() {
        this.storeSceneContainerDiv.classList.add('hidden')
    }

    show(hash?: string, value?: string) {
        this.storeSceneContainerDiv.classList.remove('hidden')

        this.sidebarController.activateStore()

        if(!UIDStoreSceneController.shouldShowDiscordShareActivityLinkPopup(hash, value)) return

        ViewPopupRewardsProgram.showDiscordShareActivityLinkPopup(ShareActivityLinkAnalytics.PushReferrersToInviteMorePlayersPopupTriggered, ShareActivityLinkAnalytics.PushReferrersToInviteMorePlayersSuccessfullyShared)
    }

    private static shouldShowDiscordShareActivityLinkPopup(hash?: string, value?: string): boolean {
        if(hash != 'referrals') return false
        if(value?.includes('showpopup') == false) return false
        return true
    }
}
